import { operations } from 'src/app/helpers/binaries';
import { EAlgiDurumu, EEngamentRule } from 'src/enums/mixed.enum';
import { userTypes } from 'src/types';
import { EtmenSiniflariResultType } from 'src/types/services/hymotsc/etmen-siniflari.type';
import { EtmenTurleriResultType } from 'src/types/services/hymotsc/etmen-turleri.type';
import { EtmenResultType } from 'src/types/services/hymotsc/etmen.type';
import { InsanYapimiEngelTuruResultType } from 'src/types/services/hymotsc/insan-yapimi-engel-turu.type';
import { TaraflarResultType } from 'src/types/services/hymotsc/taraflar.type';
import { EnvironmentalUnit, MapUnit } from 'src/types/unit.type';

export const generator = (
  etmen: EtmenResultType,
  etmenTurleri: EtmenTurleriResultType[],
  etmenSiniflari: EtmenSiniflariResultType[],
  taraflar: TaraflarResultType[],
  obstacles: InsanYapimiEngelTuruResultType[],
  allControllingUnitIds?: number[],
): MapUnit | void => {
  const { etmenTuruId } = etmen;

  const etmenTuru = etmenTurleri.find((o) => o.id === etmenTuruId);

  if (etmenTuru) {
    const { etmenSinifiId } = etmenTuru;

    const etmenSinifi = etmenSiniflari.find((o) => o.id === etmenSinifiId);

    if (etmenSinifi) {
      const { tarafId } = etmenSinifi;

      const taraf = taraflar.find((o) => o.id === tarafId);

      if (taraf) {
        const unit: MapUnit = {
          id: etmen.id,
          aboneMi: true,
          isUpdated: true,
          eklentiId: etmen.eklentiId || 0,
          aisDurumu: etmen.aisDurumu,
          createdAtSimulation: etmen.createdAtSimulation,
          kisaIsim: etmen.kisaIsim,
          kisaIsimOrg: etmen.kisaIsim,
          uzunIsim: etmen.uzunIsim,
          uzunIsimOrg: etmen.uzunIsim,
          konum: etmen.konum,
          isActive: etmen.mapActive,
          magicIkmal: etmen.magicIkmal || false,
          etmenAktiflikDurumu: etmen.etmenAktiflikDurumu,
          rota: [],
          rotaSirasi: 0,
          rotaBolgeMi: false,
          etmenTipi: etmen.etmenTipi,
          emirler: [],
          kontrolBolgesi: [],
          emirIcraEdiyorMu: etmen.emirIcraEdiyorMu,
          emirId: etmen.emirId,

          istikamet: etmen.istikamet,
          faaliyeti: etmen.faaliyeti,
          insanZayiatOrani: etmen.insanZayiatOrani,
          otonomZayiatOrani: etmen.otonomZayiatOrani,
          harekatSafhasi: -1,

          angajmanKurali: EEngamentRule['WEAPONS TIGHT'],
          ustIsletenEtmenVtId: etmen.bagliOlduguEtmenId,
          ikmalindenSorumluEtmenVtId: etmen.ikmaldenSorumluEtmenId,
          hiz: 0,
          hacim: etmen.hacim,
          etkinlik: etmenTuru.etmenTurununEtkinligi,
          bindirilmisMi: false,
          manifesto: [],
          savunma: {
            atesEdenSonEtmenId: 0,
            hazirlikSuresi: 0,
            ortmeOyalamaSuresi: 0,
            savunmaYuzdesi: 0,
          },
          havadaBekliyorMu: etmen.havadaBekliyorMu,
          beklemeSuresi: etmen.beklemeSuresi,
          supplyStatus:
            etmenTuru.ikmalDurumlari?.map((o) => {
              return {
                ikmalId: o.ikmalId,
                currentAmount: o.mevcut,
                targetAmount: o.hedefSeviye,
                autoResupply: o.otomatikYenidenIkmalSeviyesi,
              };
            }) || [],

          systemStatus:
            etmenTuru.tmkDurumlari?.map((o) => {
              return {
                tmkId: o.tmkId,
                casualty: 0,
                wounded: 0,
                currentAmount: o.toplamKadro,
                karistirilmis: 0,
                kbrnEtkisinde: 0,
                unsurAktif: undefined,
              };
            }) || [],

          navalcraftsStatus:
            etmenTuru.denizAraclari?.map((o) => {
              return {
                denizAraciId: o.denizAraciId,
                casualty: 0,
                wounded: 0,
                currentAmount: o.miktar,
                karistirilmis: 0,
                kbrnEtkisinde: 0,
                unsurAktif: undefined,
              };
            }) || [],

          aircraftsStatus:
            etmenTuru.havaAraclari?.map((o) => {
              return {
                havaAraciId: o.havaAraciId,
                casualty: 0,
                wounded: 0,
                currentAmount: o.miktar,
                karistirilmis: 0,
                kbrnEtkisinde: 0,
                unsurAktif: undefined,
              };
            }) || [],

          spacecraftsStatus:
            etmenTuru.uzayAraclari?.map((o) => {
              return {
                uzayAraciId: o.uzayAraciId,
                casualty: 0,
                wounded: 0,
                currentAmount: o.miktar,
                karistirilmis: 0,
                kbrnEtkisinde: 0,
                unsurAktif: undefined,
              };
            }) || [],

          commDevicesStatus:
            etmenTuru.muhabereCihazlari?.map((o) => {
              return {
                muhabereCihaziId: o.muhabereCihaziId,
                casualty: 0,
                wounded: 0,
                currentAmount: o.miktar,
                karistirilmis: 0,
                kbrnEtkisinde: 0,
                unsurAktif: undefined,
              };
            }) || [],

          obstaclesStatus:
            etmenTuru.engeller?.flatMap((o) => {
              const obs = obstacles.find((item) => item.id === o.engelId);

              const hasEngelMevcutlari = obs
                ? operations.hasPart(operations.toBinaryString(obs.kategori, 2, 16), ['10', '11'], 11)
                : false;

              return {
                engelId: o.engelId,
                casualty: 0,
                wounded: 0,
                currentAmount: o.miktar,
                karistirilmis: 0,
                kbrnEtkisinde: 0,
                unsurAktif: undefined,
                engelMevcutlari:
                  hasEngelMevcutlari && obs
                    ? {
                        antiPersonelMiktari: obs.etkiOlasiligiIleIlgiliParametreler.antiPersonelMiktari * o.miktar,
                        antiAracMiktari: obs.etkiOlasiligiIleIlgiliParametreler.antiAracMiktari * o.miktar,
                        antiZirhliMiktari: obs.etkiOlasiligiIleIlgiliParametreler.antiZirhliMiktari * o.miktar,
                        AntiIndirmeCikartmaMiktari:
                          obs.etkiOlasiligiIleIlgiliParametreler.AntiIndirmeCikartmaMiktari * o.miktar,
                      }
                    : undefined,
              };
            }) || [],

          etmenTuru: {
            id: etmenTuru.id,
            kisaIsim: etmenTuru.kisaIsim,
            uzunIsim: etmenTuru.uzunIsim,
            buyuklugu: etmenTuru.buyuklugu,
            sembolu: etmenTuru.sembolu,
            sidc: etmenTuru.sidc,
          },
          etmenSinifi: {
            id: etmenSinifi.id,
            kisaIsim: etmenSinifi.kisaIsim,
            uzunIsim: etmenSinifi.uzunIsim,
          },

          etmenTuruOrg: {
            id: etmenTuru.id,
            kisaIsim: etmenTuru.kisaIsim,
            uzunIsim: etmenTuru.uzunIsim,
            buyuklugu: etmenTuru.buyuklugu,
            sembolu: etmenTuru.sembolu,
            sidc: etmenTuru.sidc,
          },
          etmenSinifiOrg: {
            id: etmenSinifi.id,
            kisaIsim: etmenSinifi.kisaIsim,
            uzunIsim: etmenSinifi.uzunIsim,
          },

          taraf: {
            id: taraf.id,
            kisaIsim: taraf.kisaIsim,
            uzunIsim: taraf.uzunIsim,
            ucKarakterlikKodu: taraf.ucKarakterlikKodu,
            rengi: taraf.rengi,
          },

          tarafOrg: {
            id: taraf.id,
            kisaIsim: taraf.kisaIsim,
            uzunIsim: taraf.uzunIsim,
            ucKarakterlikKodu: taraf.ucKarakterlikKodu,
            rengi: taraf.rengi,
          },

          muhabereVektörü: [],
          muhabereKaraListe: [],

          algiDurumu: EAlgiDurumu.Self,
          sonBilinenAlgiDurumu: etmen.sonBilinenAlgiDurumu,
        };

        return unit;
      }
    }
  }
};

export const cevreselEtmenGenerator = (etmen: any) => {
  const unit: EnvironmentalUnit = {
    id: etmen.id,
    isUpdated: true,
    algiDurumu: EAlgiDurumu.Self,
    details: {},
    konum: etmen.konum || 0,
    latlngs: etmen.poligon || 0,
    yaricap: etmen.yaricap,
    tipi: etmen.tipi,
    disYaricap: etmen.disYaricap || etmen.yaricap || 0,
    aci: etmen.aci || 0,
    istikamet: etmen.istikamet || 0,
    eklentiId: etmen.eklentiId,
    vtId: etmen.vtId,
    etmenTipi: etmen.etmenTipi,
    kisaIsim: etmen.kisaIsim,
    runTimeSirasindaOlusturuldu: true,
  };

  return unit;
};
